export * from './getTimeDateObjectFromString';
export * from './formatStartEndSlotHours';
export * from './formatStartEndHours';
export * from './dateParseISO';
export * from './getFirstMondayBefore';
export * from './getTimeFromSchedule';
export * from './calculateEndTimeFromDuration';
import { parse } from 'date-fns';

/**
 * Parse a API formatted date in the form
 * yyyy-MM-dd
 * @param str
 */
export function parseApiDate(str: string): Date {
  return parseApiDatetime(`${str} 00:00:00`);
}

/**
 * Parse a API formatted datetime in the form
 * yyyy-MM-dd HH:mm:ss
 * @param str
 */
export function parseApiDatetime(str: string): Date {
  return parse(str, 'yyyy-MM-dd HH:mm:ss', new Date());
}

export * from './dateFnsTz';